// src/types/auth.ts
import { z } from 'zod'

export const jwtPayloadSchema = z
  .object({
    exp: z.number().int().positive(),
    iat: z.number().int().positive().optional(),

    username: z.string().trim().min(1).max(255),

    firstName: z.string().trim().min(1).max(255).nullish(),

    lastName: z.string().trim().min(1).max(255).nullish(),

    roles: z
      .array(z.string().trim().min(1))
      .nullish()
      .transform((roles) => roles ?? []),
  })
  .transform((payload) => ({
    exp: payload.exp,
    ...(payload.iat !== undefined ? { iat: payload.iat } : {}),

    username: payload.username,
    roles: payload.roles,

    ...(payload.firstName != null ? { firstName: payload.firstName } : {}),

    ...(payload.lastName != null ? { lastName: payload.lastName } : {}),
  }))

export type User = z.output<typeof jwtPayloadSchema>
